import { MatDateFormats } from '@angular/material/core';

export const regularExpressions = {
  "EMailValidation": /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
};

export const widgetAdderColor = "#84be6f";
/**
 * the backend's server location
 */
//export const serverLocation = "http://localhost:50367"; // USING LOCAL SERVER
export const serverLocation = "https://ams.campus-netz.services/backend"; // USING LIVE SERVER

export const customerClientURI = "https://ams.campus-netz.services/customer-client";

/**
 * the known audit actions
 */
export const auditActions = {
  "create": {
    color: "#64a52f",
    title: "Neu angelegt",
    icon: "flare",
    internalRef: 0,
    bg: "rgb(239, 255, 226)",
    method: "getNew"
  },
  "update": {
    color: "rgb(23, 90, 173)",
    title: "Bearbeitet",
    icon: "edit",
    internalRef: 1,
    bg: "rgb(201, 221, 245)",
    method: "getChanges"
  },
  "edit": {
    color: "rgb(23, 90, 173)",
    title: "Bearbeitet",
    icon: "edit",
    internalRef: 1,
    bg: "rgb(201, 221, 245)",
    method: "getChanges"
  },
  "delete": {
    color: "rgb(227, 27, 90)",
    title: "Gelöscht",
    icon: "delete_forever",
    internalRef: 2,
    bg: "rgb(240, 185, 202)",
    method: "getOld"
  }
}

/**
 * a guid
 */
export class Guid {
  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

export const DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD.MM.yyyy'
  },
  display: {
    dateInput: 'DD.MM.yyyy',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  }
};

export const modules = {
  readOnly: false,
  toolbar: {
    container:
      [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['code-block'],

        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],

        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
        [{ 'font': [] }],
        [{ 'align': [] }],

        ['clean']                                    // remove formatting button
      ]
  }
};

export class CountryData {
  name: string;
  flagIcon: string;
}

export const ger = {
  name: "Deutschland",
  flagIcon: "flag-icon-de"
} as CountryData;

export const countries: CountryData[] = [
  ger, {
    name: "Dänemark",
    flagIcon: "flag-icon-dk"
  }, {
    name: "Frankreich",
    flagIcon: "flag-icon-fr"
  }, {
    name: "Italien",
    flagIcon: "flag-icon-it"
  }, {
    name: "Österreich",
    flagIcon: "flag-icon-at"
  }, {
    name: "Polen",
    flagIcon: "flag-icon-pl"
  }, {
    name: "Schweiz",
    flagIcon: "flag-icon-ch"
  }, {
    name: "Spanien",
    flagIcon: "flag-icon-es"
  }, {
    name: "Tschechien",
    flagIcon: "flag-icon-cz"
  }, {
    name: "USA",
    flagIcon: "flag-icon-us"
  }];

export const widgets = {
  "AvailabilityRequestWidget": {
    "pretty": "Standortwidget"
  },
  "CalendarWidget": {
    "pretty": "Kalenderwidget"
  },
  "ChangeWidget": {
    "pretty": "RFC-/Changewidget"
  },
  "ChartWidget": {
    "pretty": "Diagrammwidget"
  },
  "ContactPersonalWidget": {
    "pretty": "Ansprechpartnerwidget"
  },
  "ContractWidget": {
    "pretty": "Vertragswidget"
  },
  "CustomerWidget": {
    "pretty": "Kundenwidget"
  },
  "DocumentWidget": {
    "pretty": "Dokumentenwidget"
  },
  "IFrameWidget": {
    "pretty": "IFramewidget"
  },
  "IncidentMailWidget": {
    "pretty": "Ticketeingangswidget"
  },
  "IncidentWidget": {
    "pretty": "Ticketwidget"
  },
  "IssueMailWidget": {
    "pretty": "Auftragseingangwidget"
  },
  "IssueWidget": {
    "pretty": "Vorgangswidget"
  },
  "OfferWidget": {
    "pretty": "Angebotswidget"
  },
  "ProjectWidget": {
    "pretty": "Projektwidget"
  }
}

export function plainMailToHTML(input: string): string {
  if (typeof input !== 'string') return null;
  return input.replace(/(?:\r\n|\r|\n)/g, '<br>')
    .replace(/\*(.*?(?:))\*/g, '<strong>$1</strong>');
}

export function compare(a: number | string, b: number | string, isAsc: boolean = true) {
  if (!a) a = '';
  if (!b) b = '';
  if (typeof (a) === 'string') a = a.trim().toLocaleLowerCase();
  if (typeof (b) === 'string') b = b.trim().toLocaleLowerCase();
  let result = (a < b ? -1 : a > b ? 1 : 0) * (isAsc ? 1 : -1);
  return result;
}

export const maxImageSizeBytes = 500000;

export function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(',')[1]);

  // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  var ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  var blob = new Blob([ab], { type: mimeString });
  return blob;

}

export function pickHex(color1, color2, weight) {
  var w1 = weight;
  var w2 = 1 - w1;
  var rgb = [Math.round(color1[0] * w1 + color2[0] * w2),
      Math.round(color1[1] * w1 + color2[1] * w2),
      Math.round(color1[2] * w1 + color2[2] * w2)];
  return rgb;
}
